<div class="tabs-row">
	<div
		*ngFor="let tab of tabList; index as tabIndex"
		[ngClass]="{
			selected: tabIndex === selectedTabIndex,
			disabled: tab.state === 'disabled',
			hidden: tab.state === 'hidden'
		}"
		(click)="clickTab(tabIndex)"
		pTooltip="{{ tab.tooltip | translate }}"
		tooltipPosition="top"
		class="tab zk-flex zk-gap-2 zk-items-center"
	>
		<span *ngIf="tab.icon" [class]="'freud-icon ' + tab.icon"></span>
		{{ tab.name | translate }}
		<freud-tag
			*ngIf="tab.tagValue"
			[value]="tab.tagValue | translate"
		></freud-tag>
	</div>
</div>
<div class="base-border"></div>
